import { withSpinner, success } from "../../../../redux/actions/utilities";
import {
  featureFlagsReduxConstants,
  successMessages,
  toastTypes,
  errorMessages,
} from "../../constants";
import { customToast } from "../../../../shared";
import { featureFlagsServices } from "../../services";

const { GET_ALL_BRANDS_FOR_FEATURE_FLAGS, UPDATE_FEATURE_FLAG_FOR_BRAND } =
  featureFlagsReduxConstants;

//Fetching brand locations paginated data
const getAllBrandsForFeatureFlags = (body) => {
  return (dispatch) => {
    withSpinner(dispatch, GET_ALL_BRANDS_FOR_FEATURE_FLAGS, () =>
      featureFlagsServices
        .getAllBrandsForFeatureFlags(body)
        .then(
          (response) => {
            dispatch(success(response, GET_ALL_BRANDS_FOR_FEATURE_FLAGS));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

const updateFeatureFlag = (body, isStoreUpdate) => {
  const handleFeatureFlagUpdate = isStoreUpdate
    ? featureFlagsServices.updateFeatureFlagForStore
    : featureFlagsServices.updateFeatureFlagForBrand;
  return (dispatch) => {
    return withSpinner(dispatch, UPDATE_FEATURE_FLAG_FOR_BRAND, () =>
      handleFeatureFlagUpdate(body)
        .then(
          (_response) => {
            dispatch(success(body, UPDATE_FEATURE_FLAG_FOR_BRAND));
            customToast(successMessages.UPDATED_SUCCESSFULLY, toastTypes.SUCCESS);
          },
          (error) => {
            const errorMessage = error[0] || errorMessages.FAILED_TO_UPDATE;
            customToast(errorMessage, toastTypes.ERROR);
            throw error;
          }
        )
    );
  };
};

export const featureFlagsActions = {
  getAllBrandsForFeatureFlags,
  updateFeatureFlag,
};
